import { useContext, useEffect, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { GET_INSTALLER_QUERY } from 'Queries/Queries';
import { ErrorHandlingContext } from 'context/ErrorHandling';

import { applyFachinteressentMock } from 'components/CardCollectionMyData/MyDataTestSetup';
import {
  DEB_CURRENT_TEST_SUITE,
  shouldFillDebTestData,
} from 'components/DEBForm/Utils/DebTestSetup';

export const useCurrentInstaller = ({ skip = false, suppressError = false } = {}) => {
  const { setShowError } = useContext(ErrorHandlingContext);
  const { data, loading, error, refetch } = useQuery(GET_INSTALLER_QUERY, {
    skip,
  });

  const installer = useMemo(() => {
    const baseInstaller = shouldFillDebTestData
      ? DEB_CURRENT_TEST_SUITE.installerData
      : data?.getInstaller ?? null;

    return applyFachinteressentMock(baseInstaller);
  }, [data]);

  useEffect(() => {
    if (error && !suppressError) {
      console.error('useCurrentInstaller error:', error);
      setShowError((prev) => !prev && true); // Prevent multiple triggers
    }
  }, [error, setShowError, suppressError]);

  return {
    installer,
    isLoading: loading,
    error,
    hasInstallerResponse: data !== undefined,
    refetchInstaller: refetch,
  };
};
